
// 10 levels, easy -> extreme. Each level pairs an obstacle pattern with a
// starting snake speed. Patterns are generated (not hand-typed) and always
// keep a safe zone clear around the snake's spawn point (id09_10) so a new
// level never starts with an instant collision.

function pad(n) {
    return ("0" + n).slice(-2);
}
function id(r, c) {
    return "id" + pad(r) + "_" + pad(c);
}

const N = 20;
const SAFE = { r1: 7, r2: 13, c1: 6, c2: 15 };
const inSafeZone = (r, c) => r >= SAFE.r1 && r <= SAFE.r2 && c >= SAFE.c1 && c <= SAFE.c2;

function border() {
    const cells = [];
    for (let c = 1; c <= N; c++) { cells.push([1, c]); cells.push([N, c]); }
    for (let r = 2; r < N; r++) { cells.push([r, 1]); cells.push([r, N]); }
    return cells;
}
function hLine(r, c1, c2) {
    const cells = [];
    for (let c = c1; c <= c2; c++) cells.push([r, c]);
    return cells;
}
function vLine(c, r1, r2) {
    const cells = [];
    for (let r = r1; r <= r2; r++) cells.push([r, c]);
    return cells;
}
function dots(points) {
    return points;
}

function build(...groups) {
    const seen = new Set();
    const out = [];
    for (const [r, c] of groups.flat()) {
        if (r < 1 || r > N || c < 1 || c > N) continue;
        if (inSafeZone(r, c)) continue;
        const boxId = id(r, c);
        if (!seen.has(boxId)) {
            seen.add(boxId);
            out.push(boxId);
        }
    }
    return out;
}

const LEVELS = [
    {
        id: 1, name: "Open Meadow", difficulty: "Easy", speed: 520,
        pattern: build([])
    },
    {
        id: 2, name: "Drifting Stones", difficulty: "Easy", speed: 490,
        pattern: build(dots([[4, 4], [4, 17], [17, 4], [17, 17], [10, 3], [10, 18], [3, 10], [18, 10]]))
    },
    {
        id: 3, name: "The Horizon Line", difficulty: "Easy+", speed: 465,
        pattern: build(border())
    },
    {
        id: 4, name: "Twin Pillars", difficulty: "Medium", speed: 440,
        pattern: build(border(), vLine(5, 2, 6), vLine(16, 2, 6), vLine(5, 15, 19), vLine(16, 15, 19))
    },
    {
        id: 5, name: "Crossed Paths", difficulty: "Medium", speed: 415,
        pattern: build(border(), hLine(10, 2, 5), hLine(10, 16, 19), vLine(10, 2, 5), vLine(10, 16, 19))
    },
    {
        id: 6, name: "Floating Fence", difficulty: "Medium+", speed: 390,
        pattern: build(border(), hLine(5, 3, 9), hLine(5, 12, 18), hLine(16, 3, 9), hLine(16, 12, 18))
    },
    {
        id: 7, name: "The Maze Awakens", difficulty: "Hard", speed: 365,
        pattern: build(
            border(),
            vLine(5, 2, 6), vLine(16, 2, 6), vLine(5, 15, 19), vLine(16, 15, 19),
            hLine(10, 2, 5), hLine(10, 16, 19), vLine(10, 2, 5), vLine(10, 16, 19)
        )
    },
    {
        id: 8, name: "Narrow Corridors", difficulty: "Hard", speed: 340,
        pattern: build(
            border(),
            vLine(5, 2, 6), vLine(5, 15, 19), vLine(16, 2, 6), vLine(16, 15, 19),
            hLine(5, 3, 9), hLine(5, 12, 18), hLine(16, 3, 9), hLine(16, 12, 18)
        )
    },
    {
        id: 9, name: "Eye of the Storm", difficulty: "Extreme", speed: 310,
        pattern: build(
            border(),
            hLine(4, 2, 9), hLine(4, 12, 19), hLine(17, 2, 9), hLine(17, 12, 19),
            vLine(4, 2, 9), vLine(4, 12, 19), vLine(17, 2, 9), vLine(17, 12, 19)
        )
    },
    {
        id: 10, name: "Labyrinth's Heart", difficulty: "Extreme", speed: 280,
        pattern: build(
            border(),
            vLine(5, 2, 6), vLine(16, 2, 6), vLine(5, 15, 19), vLine(16, 15, 19),
            hLine(5, 3, 9), hLine(5, 12, 18), hLine(16, 3, 9), hLine(16, 12, 18),
            hLine(4, 2, 9), hLine(4, 12, 19), hLine(17, 2, 9), hLine(17, 12, 19),
            dots([[8, 3], [8, 18], [13, 3], [13, 18]])
        )
    }
];

export default LEVELS;
export { LEVELS };
